module.exports = __webpack_public_path__ + "img/ipf2fround.64b4d977.svg";